"use strict";
exports.__esModule = true;
exports.validateTextInput = exports.updateNestedData = void 0;
/**
 * Dynamically sets a deeply nested value in an object.
 * @function
 * @param obj - The object which contains the value you want to change/set.
 * @param path  - The array representation of path to the value you want to change/set.
 * @param value - The value you want to set it to.
 */
exports.updateNestedData = function (obj, path, value) {
    path.reduce(function (data, key, level) {
        if (level + 1 === path.length) {
            data[key] = value;
            return value;
        }
        return data[key];
    }, obj);
};
/**
 * Empty space check - prevent user from entering only spaces
 * @function
 * @param value - The value which needs to be validated
 */
exports.validateTextInput = function (value) {
    var emptySpaceCheck = /^[^-\s][a-zA-Z0-9_\s-]+$/i;
    return emptySpaceCheck.test(value);
};
